import { SxProps, Tab, Tabs, TabsProps, Theme } from '@mui/material';
import { Link } from 'react-router';
import { StyleObj, TabConfigItem } from '../../@types';
import omit from 'lodash-es/omit';
import { mergeSx } from '../../utils/styles';

const styles: StyleObj = {
  tabs: {
    minHeight: 0,
    '& .MuiTab-root': {
      minHeight: 0,
      minWidth: 0,
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'info.main',
      color: 'neutral.700',
      height: '100%',
      borderRadius: '100px',
      transition: 'all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
    },
    '& .MuiTabs-list': {
      gap: 1.25,
    },
  },
  tab: {
    typography: {
      xs: 'body3',
      md: 'body2',
    },
    letterSpacing: { xs: 0 },
    textTransform: 'none',
    borderRadius: '100px',
    px: {
      xs: 1,
      md: 1.5,
    },
    py: {
      xs: 0.25,
      md: 0.5,
    },
    color: 'inherit',
    '&.Mui-selected': {
      color: 'neutral.700',
      fontWeight: 700,
      zIndex: 10,
      transition: 'color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;',
    },
  },
};

type StyledHeaderTabsProps<T> = TabsProps & {
  tabConfig: TabConfigItem<T>[];
  linkPrefix?: string;
  tabAsLink?: boolean;
  sx?: SxProps<Theme>;
  tabSx?: SxProps<Theme>;
};

const StyledHeaderTabs = <T,>({ tabConfig, tabAsLink = false, linkPrefix, ...props }: StyledHeaderTabsProps<T>) => (
  <Tabs {...omit(props, 'setValue')} variant='scrollable' scrollButtons='auto' sx={mergeSx(styles.tabs, props.sx)}>
    {tabConfig?.map((tab) => (
      <Tab
        key={tab.value as string}
        component={tabAsLink ? Link : 'div'}
        label={tab.label}
        value={tab.value}
        to={tabAsLink ? `${linkPrefix}/${tab.value}` : undefined}
        sx={mergeSx(styles.tab, props.tabSx)}
      />
    ))}
  </Tabs>
);

export default StyledHeaderTabs;
